import React, { useEffect, useState } from "react";
import { Table, Button, IconPlus, Search, IconDownload } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import UploadModalDate from './UploadModalDate';
import XLSX from "xlsx";
import $ from 'jquery';

const LSMarkRender = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataLSMark, setDataLSMark] = useState([]);
    const [dataListLS, setDataListLS] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [datacounter, setdatacounter]=useState(1);

    //Metodos
    const fetchData = async () => {
        setDateSelected('');
        setDataLSMark([]);

        connectApi.get(
            "api/Channels/AllTables",
            { params: { viewRequired: 'lsMark' } },
            dataResponseLoad
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
        setLoadingData(true);
    };
    const dataResponseLoad = (status, data) => {
        setDateSelected( moment(data['date']).format("MM-DD-YYYY") );
        setDataLSMark(data['lsMark'] === undefined ? [] : data['lsMark']);
        // dataListGT dataListRL
        setDataListLS(data['dataListLS'] === undefined ? [] : data['dataListLS']);
        setLoadingData(false)
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
    }, [datacounter]);

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if (  orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } if( orderBy === "channel" || orderBy === "name" 
            || orderBy === "createdBy" || orderBy === "classification" 
            || orderBy === "description" || orderBy==="namecustomer" || orderBy==="nameEndUser" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate"
                || orderBy === "date" || orderBy === "monthYear" ){
   
                    
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    //Vista
    const [showModalLS, setShowModalLS] = useState(false);
    const [orderBy, setOrderBy] = useState("none");
    const [orderType, setOrderType] = useState("descending");
    const [nameFilter, setNameFilter] = useState("");
    const [channelFilter, setChannelFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [ItemSelectLSMark, setItemSelectLSMark]=useState([]);
    const [ModifyValuesLSMark, setModifyValuesLSMark]=useState(false);
    const pageSize = 25;
    const [order, setOrder] = useState([
        'channel',
        'name',
        'idPress',
        'year',
        'month',
        'lsMark'
    ]);
    const handlePageChange = (page) => setCurrentPage(page);
    const filteredData = filterSort(
        dataLSMark, {
            name: nameFilter,
            channel: channelFilter,
        },
        orderBy,
        orderType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    function setModalParameters(e){
        var channelGlobalTier = $(e.target).closest('tr').children().eq(0).text();
        var nameGlobalTier = $(e.target).closest('tr').children().eq(1).text();
        var pressidGlobalTier = $(e.target).closest('tr').children().eq(2).text();
        var yearGlobalTier = $(e.target).closest('tr').children().eq(3).text();
        var monthGlobalTier = $(e.target).closest('tr').children().eq(4).text();
        var lsmarkGlobalTier = $(e.target).closest('tr').children().eq(5).text();

        if( channelGlobalTier !== 'Channel' & nameGlobalTier !== 'End user' & pressidGlobalTier!=='Press ID' & yearGlobalTier!=='Year' & monthGlobalTier!=='Month' 
        & lsmarkGlobalTier!=='LSMark Value'  & new Date(dateSelected).getMonth() <= monthGlobalTier & new Date(dateSelected).getFullYear() <= yearGlobalTier){
            let vaItem = dataLSMark.find(gt => gt.channel === channelGlobalTier & gt.name === nameGlobalTier 
                & gt.month===monthGlobalTier & gt.year===yearGlobalTier & gt.idPress === pressidGlobalTier );
            setItemSelectLSMark(vaItem);
            setModifyValuesLSMark(true);
            setShowModalLS(true);
        }
    };
        
    return (<div>
        <Row>
            <Col 
                style={{
                    position: "absolute",
                    marginTop: "5px",
                }}
            >
                <Button
                    leadingIcon={<IconPlus />}
                    onClick={() => {setShowModalLS(true);setModifyValuesLSMark(false);}}
                    loading={loadingData}
                >{t("addNew")} LSMark</Button>
            </Col>
        </Row>
        <div>
            <Table
                onClick={setModalParameters}
                columns = {[
                    {
                        id: 'channel',
                        label: t("channel"),
                        filter: (
                            <Search
                                id="channel-filter"
                                value={channelFilter}
                                onChange={(val) => {
                                    setChannelFilter(val);
                                    setCurrentPage(1);
                                }}
                            />
                        )
                    },
                    {
                        id: 'name',
                        label: t("endUser"),
                        filter: (
                            <Search
                                id="endUserName-filter"
                                value={nameFilter}
                                onChange={(val) => {
                                    setNameFilter(val);
                                    setCurrentPage(1);
                                }}
                            />
                        )
                    },
                    {
                        id: 'idPress',
                        label: t('press id')
                    },
                    {
                        id: 'year',
                        label: t('year')
                    },
                    {
                        id: 'month',
                        label: t('month')
                    },
                    {
                        id: 'lsMark',
                        label: "LSMark " + t("value")
                    },
                ]}
                showFilters
                columnReorder
                data={pagedData}
                loading={loadingData}
                onSort={handleSort}
                onColumnReorder={(reOrder) => setOrder(reOrder)}
                preferences={{
                    defaultOrder: order,
                    sortBy: {
                        id: orderBy,
                        type: orderType,
                    },
                    order: order
                }}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems: filteredData.length,
                }}
            />
            <div style={{ textAlign: "left" }}>
                <Button
                    onClick={()=>{
                        setTimeout(() => {
                        const dataXlsx = filteredData.map((item) => { return item; });
                        const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                        const wb = XLSX.utils.book_new();
                        const date = moment(new Date()).format('YYYYMMDDHHmm');
                        const filename = 'GlobalTier-' + date + '.xlsx';
                        const ws_name = "GlobalTier";
                        XLSX.utils.book_append_sheet(wb, ws, ws_name);
                        XLSX.writeFile(wb, filename);
                        }, 750);
                    }}
                    disabled={filteredData.length === 0}
                    leadingIcon={<IconDownload />}
                    title={t('download data')}
                    >
                    {t('download')}
                </Button>
            </div>
        </div>
        <UploadModalDate
            key={showModalLS ? true : false}
            showModal={showModalLS}
            setShowModal={setShowModalLS}
            tabView="lsMark"
            dataList={dataListLS}
            dateInit={dateSelected}
            fetchData={useEffect}
            valueModify={ModifyValuesLSMark}
            setValueModify={setModifyValuesLSMark}
            itemModify={ItemSelectLSMark}
            datacounter={datacounter}
            setdatacounter={setdatacounter}
        />
    </div>);
}

export default LSMarkRender;